<script>
import { Line } from 'vue-chartjs'

export default {
	extends: Line,
	props: ['data', 'height'],
	mounted () {
		this.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
			datasets: [
				{
					backgroundColor: 'rgba(255,255,255,.1)',
					borderColor: 'rgba(255,255,255,.55)',
					pointHoverBackgroundColor: '#fff',
					borderWidth: 2,
					data: this.data
				}
			]
		}, {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false
			},
			scales: {
				xAxes: [{
					display: false
				}],
				yAxes: [{
					display: false
				}]
			},
			elements: {
				point: {
					radius: 0,
					hitRadius: 10,
					hoverRadius: 4,
					hoverBorderWidth: 3
				}
			}
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SocialBoxChartExample.vue